/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getWorkerWorkHistory } from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";
import { format } from "date-fns";
import { useSearchParams } from "react-router-dom";
import { getTypeofWork } from "../../../../utils/utils";
import JobModal from "./ViewWorkhistory/View";

const WorkHistory = () => {
    const { state } = useAuth();
    const [loading, setLoading] = useState(true);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [totalCount, setTotalCount] = useState(0);
    const [searchParams] = useSearchParams();
    const [workerData, setWorkerData] = useState<any>([]);
    const [open, setOpen] = useState(false);
    const [selectedJob, setSelectedJob] = useState<any>(null);

    const handleOpen = (row: any) => {
        setSelectedJob(row.job);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedJob(null);
    };

    const getSafetydata = async () => {
        try {
            setLoading(true);
            const response = await getWorkerWorkHistory(
                state.user?.token,
                searchParams.get('workerId'),
                pageNumber,
                pageSize,
            );
            setWorkerData(response?.data.items || []);
            setTotalCount(response?.data.totalCount || 0);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getSafetydata();
    }, [pageNumber, pageSize]);

    useEffect(() => {
        setPageNumber(1);
    }, [searchParams.get('workerId')]);

    const columns: any = [
        {
            field: "whatsAppName",
            headerName: "Team Name",
            flex: 0.5,
            renderCell: (params: any) => (
                <div>{params.row.job?.whatsAppName}</div>
            ),
        },
        {
            field: "client",
            headerName: "Client",
            flex: 0.5,
            renderCell: (params: any) => (
                <div>
                    {params.row.job?.projectName} - {params.row.job.companyName} {getTypeofWork(params.row.job?.region)}
                </div>
            ),
        },
        {
            field: "postCode",
            headerName: "Site",
            flex: 0.5,
            renderCell: (params: any) => (
                <div>
                    {params.row.job.location} - {params.row.job.postCode}
                </div>
            ),
        },
        {
            field: "clientSiteContact",
            headerName: "Site Contact",
            flex: 0.5,
            renderCell: (params: any) => (
                <div>{params.row.job.clientSiteContact}</div>
            ),
        },
        {
            field: "workRole",
            headerName: "Job Role",
            flex: 0.5,
            renderCell: (params: any) => (
                <div>{params.row.workRole}</div>
            ),
        },
        {
            field: "dateWorked",
            headerName: "Date Worked",
            flex: 0.5,
            renderCell: (params: any) => (
                <div>
                    {format(new Date(params.row.job.jobDate || Date.now()), 'dd/MM/yyyy')}
                </div>
            ),
        },
        {
            field: "details",
            headerName: "Details",
            flex: 0.3,
            renderCell: (params: any) => (
                <Button
                    variant="contained"
                    onClick={() => handleOpen(params.row)}
                    style={{
                        boxShadow: "none",
                        backgroundColor: "#6c757d",
                    }}
                >
                    Details
                </Button>
            ),
        },
    ];

    return (
        <Box bgcolor={"white"} padding={5}>
            <Box>
                <DataGrid
                    rows={workerData}
                    columns={columns}
                    loading={loading}
                    rowCount={totalCount}
                    paginationMode="server"
                    paginationModel={{
                        page: pageNumber - 1,
                        pageSize: pageSize,
                    }}
                    onPaginationModelChange={(model) => {
                        setPageNumber(model.page + 1);
                        setPageSize(model.pageSize);
                    }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    style={{ height: 700, width: 1790 }}
                    disableRowSelectionOnClick
                    sx={{
                        "@media (max-width: 700px)": {
                            minWidth: "100%",
                        },
                        "& .MuiDataGrid-columnHeader": {
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: 15,
                            backgroundColor: '#f0f0f0',
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                            fontWeight: "bold",
                        },
                        "& .MuiDataGrid-row:hover": {
                            backgroundColor: "#f1f1f1",
                        },
                    }}
                />
            </Box>
            <JobModal
                open={open}
                onClose={handleClose}
                jobData={selectedJob}
            />
        </Box>
    );
};

export default WorkHistory;
